// extracted by mini-css-extract-plugin
module.exports = {"priceInput":"_2uCbiarZZewsjZtZSU8HJB"};